import React, { useEffect } from "react";

export default function Modal({ open, onClose, title, children, width = "520px" }) {
  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div
        style={{ ...styles.modal, width, maxWidth: "calc(100vw - 40px)" }}
        onClick={e => e.stopPropagation()}
      >
        <div style={styles.header}>
          <h2 style={styles.title}>{title}</h2>
          <button onClick={onClose} style={styles.closeBtn}>✕</button>
        </div>
        <div style={styles.body}>{children}</div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.7)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "20px",
  },
  modal: {
    background: "#0F172A",
    border: "1px solid rgba(37,99,235,0.25)",
    borderRadius: "16px",
    boxShadow: "0 25px 60px rgba(0,0,0,0.6)",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    animation: "eq-fade-in 0.18s ease",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px 16px",
    borderBottom: "1px solid rgba(37,99,235,0.12)",
    flexShrink: 0,
  },
  title: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#F1F5F9",
    margin: 0,
    letterSpacing: "-0.3px",
  },
  closeBtn: {
    background: "rgba(51,65,85,0.6)",
    border: "none",
    borderRadius: "6px",
    color: "#94A3B8",
    width: "28px",
    height: "28px",
    cursor: "pointer",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    flexShrink: 0,
  },
  body: {
    padding: "20px 24px 24px",
    overflowY: "auto",
    flex: 1,
  },
};
